export default "__VITE_ASSET__1ff25aff__"